import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#create_entity",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Add Course")
  ])
], -1)
const _hoisted_3 = {
  id: "create_entity",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-5" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Tranche", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Partner", -1)
const _hoisted_13 = { class: "col-md-4" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Contract", -1)
const _hoisted_15 = { class: "row mt-3" }
const _hoisted_16 = { class: "col-md-3" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Course Type", -1)
const _hoisted_18 = { class: "col-md-3" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Skill Level", -1)
const _hoisted_20 = { class: "col-md-3" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Course Category", -1)
const _hoisted_22 = { class: "col-md-3" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Course Sector", -1)
const _hoisted_24 = { class: "row mt-3" }
const _hoisted_25 = { class: "col-md-4" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Unique Course Name", -1)
const _hoisted_27 = { class: "col-md-4" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Course Name")
], -1)
const _hoisted_29 = { class: "col-md-4" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Code")
], -1)
const _hoisted_31 = { class: "row mt-3" }
const _hoisted_32 = { class: "col-md-4" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Target Batch")
], -1)
const _hoisted_34 = { class: "col-md-4" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Batch Size")
], -1)
const _hoisted_36 = { class: "col-md-4" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Month")
], -1)
const _hoisted_38 = { class: "row mt-3" }
const _hoisted_39 = { class: "col-md-4" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Total Target Trainee")
], -1)
const _hoisted_41 = { class: "col-md-4" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Course Unit Cost", -1)
const _hoisted_43 = { class: "col-md-4" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Total Course Cost", -1)
const _hoisted_45 = { class: "row mt-3" }
const _hoisted_46 = { class: "col-md-3" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Minimum Day per month")
], -1)
const _hoisted_48 = { class: "col-md-2" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Hour")
], -1)
const _hoisted_50 = { class: "col-md-2" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Day")
], -1)
const _hoisted_52 = { class: "col-md-2" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Session")
], -1)
const _hoisted_54 = { class: "col-md-3" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Term")
], -1)
const _hoisted_56 = { class: "row mt-3" }
const _hoisted_57 = { class: "col-md-4" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "" }, "Min Age")
], -1)
const _hoisted_59 = { class: "col-md-4" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Max Age")
], -1)
const _hoisted_61 = { class: "col-md-4" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold form-label required" }, "Grace(M)", -1)
const _hoisted_63 = { class: "row mt-3" }
const _hoisted_64 = { class: "col-md-6" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Course Objective")
], -1)
const _hoisted_66 = { class: "col-md-6" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Entry Qualification")
], -1)
const _hoisted_68 = { class: "row mt-3" }
const _hoisted_69 = { class: "col-md-12" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Certification Authority")
], -1)
const _hoisted_71 = { class: "row mt-3 p-5" }
const _hoisted_72 = { class: "col-md-2" }
const _hoisted_73 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold" }, " Is Stipend Course? ", -1)
const _hoisted_75 = { class: "col-md-2" }
const _hoisted_76 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold" }, " Is Management Course? ", -1)
const _hoisted_78 = { class: "col-md-2" }
const _hoisted_79 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold" }, " Is Employment Eligible? ", -1)
const _hoisted_81 = { class: "col-md-2" }
const _hoisted_82 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold" }, " Is Reassessment Enabled? ", -1)
const _hoisted_84 = { class: "col-md-2" }
const _hoisted_85 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold" }, " Is ToT Course ? ", -1)
const _hoisted_87 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_88 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#course_term",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Course Term")
  ])
], -1)
const _hoisted_89 = {
  id: "course_term",
  class: "collapse show"
}
const _hoisted_90 = { class: "collapse show" }
const _hoisted_91 = { class: "card-body border-top p-5" }
const _hoisted_92 = { class: "row" }
const _hoisted_93 = { class: "col-md-1" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Term", -1)
const _hoisted_95 = { class: "col-md-2" }
const _hoisted_96 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Month", -1)
const _hoisted_97 = { class: "col-md-1" }
const _hoisted_98 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Day", -1)
const _hoisted_99 = { class: "col-md-1" }
const _hoisted_100 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Session", -1)
const _hoisted_101 = { class: "col-md-2" }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Hour", -1)
const _hoisted_103 = { class: "col-md-2" }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Class Type", -1)
const _hoisted_105 = { class: "col-md-2" }
const _hoisted_106 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Session Per Week", -1)
const _hoisted_107 = { class: "card mb-5 mb-xl-10" }
const _hoisted_108 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#course_configuration",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Course Configuration")
  ])
], -1)
const _hoisted_109 = {
  id: "course_configuration",
  class: "collapse show"
}
const _hoisted_110 = { class: "collapse show" }
const _hoisted_111 = { class: "card-body border-top p-5" }
const _hoisted_112 = { "data-kt-stepper-element": "content" }
const _hoisted_113 = { class: "row" }
const _hoisted_114 = { class: "col-md-4" }
const _hoisted_115 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Enrollment Grace (day)")
], -1)
const _hoisted_116 = { class: "col-md-4" }
const _hoisted_117 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Dropout %")
], -1)
const _hoisted_118 = /*#__PURE__*/_createElementVNode("div", { class: "form-text" }, "dropout % for assessment", -1)
const _hoisted_119 = { class: "col-md-4" }
const _hoisted_120 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Replacement %")
], -1)
const _hoisted_121 = /*#__PURE__*/_createElementVNode("div", { class: "form-text" }, " % of dropout replacement by new trainee ", -1)
const _hoisted_122 = { class: "row mt-3" }
const _hoisted_123 = { class: "col-md-4" }
const _hoisted_124 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Employment Bill Claim %")
], -1)
const _hoisted_125 = /*#__PURE__*/_createElementVNode("div", { class: "form-text" }, " % of employment required for claim. ", -1)
const _hoisted_126 = { class: "col-md-3 mt-3 p-5" }
const _hoisted_127 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_128 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold" }, " Assessment Applicable? ", -1)
const _hoisted_129 = { class: "col-md-3 mt-3 p-5" }
const _hoisted_130 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_131 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold" }, " Certification Applicable? ", -1)
const _hoisted_132 = { class: "card mb-5 mb-xl-10" }
const _hoisted_133 = {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#course_bill_configuration",
  "aria-expanded": "true",
  "aria-controls": "form"
}
const _hoisted_134 = /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Course Bill Configuration")
], -1)
const _hoisted_135 = { class: "card-title m-0" }
const _hoisted_136 = { class: "col-md-1" }
const _hoisted_137 = { class: "form-label d-flex" }
const _hoisted_138 = /*#__PURE__*/_createElementVNode("span", { class: "badge badge-primary" }, "Contribution Percentage", -1)
const _hoisted_139 = {
  key: 0,
  class: "badge badge-warning"
}
const _hoisted_140 = {
  key: 1,
  class: "badge badge-warning"
}
const _hoisted_141 = {
  id: "course_bill_configuration",
  class: "collapse show"
}
const _hoisted_142 = { class: "collapse show" }
const _hoisted_143 = { class: "card-body border-top p-5" }
const _hoisted_144 = { "data-kt-stepper-element": "content" }
const _hoisted_145 = { class: "row mt-2" }
const _hoisted_146 = { class: "col-md-2" }
const _hoisted_147 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Claim", -1)
const _hoisted_148 = { class: "col-md-3" }
const _hoisted_149 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Milestone ", -1)
const _hoisted_150 = { class: "col-md-2" }
const _hoisted_151 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Claim%", -1)
const _hoisted_152 = { class: "col-md-3" }
const _hoisted_153 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Advance Adjustment %", -1)
const _hoisted_154 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "badge badge-primary" }, "Claim Cost")
  ])
], -1)
const _hoisted_155 = { class: "col-md-1" }
const _hoisted_156 = { class: "form-label" }
const _hoisted_157 = {
  key: 0,
  class: "badge badge-success"
}
const _hoisted_158 = {
  key: 1,
  class: "badge badge-success"
}
const _hoisted_159 = { class: "d-flex" }
const _hoisted_160 = ["data-kt-indicator"]
const _hoisted_161 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_162 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_163 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_164 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, {
    onSubmit: _cache[46] || (_cache[46] = ($event: any) => (_ctx.formSubmit())),
    class: "form",
    "validation-schema": _ctx.AssociationSchema
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _hoisted_10,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Tranche",
                      modelValue: _ctx.course.tranche,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.course.tranche) = $event)),
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tranche, (trans) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: trans.id,
                            label: trans.label,
                            value: trans.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(trans.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Partner",
                      modelValue: _ctx.course.entity_id,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.course.entity_id) = $event)),
                      filterable: "",
                      style: {"width":"100%"},
                      onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getContactList()))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.association, (data) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: data.id,
                            label: 
                        '[' + data.entity_short_name + '] - ' + data.entity_name
                      ,
                            value: data.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString('[' + data.entity_short_name + '] - ' + data.entity_name), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "entity_id",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Contract",
                      modelValue: _ctx.course.entity_tranche_contract_id,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.course.entity_tranche_contract_id) = $event)),
                      filterable: "",
                      style: {"width":"100%"},
                      onChange: _cache[4] || (_cache[4] = ($event: any) => (
                      _ctx.getContractPercentage(_ctx.course.entity_tranche_contract_id)
                    ))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contactList, (data) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: data.id,
                            label: data.contract_name,
                            value: data.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(data.contract_name), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "entity_tranche_contract_id",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Course Type",
                      modelValue: _ctx.course.course_type,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.course.course_type) = $event)),
                      filterable: "",
                      style: {"width":"100%"},
                      onChange: _cache[6] || (_cache[6] = ($event: any) => (this.billConfiguration(_ctx.course.course_type)))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courseList, (data) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: data.id,
                            label: data.type_name,
                            value: data.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(data.type_name), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "course_type",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Skill Level",
                      modelValue: _ctx.course.skill_level_id,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.course.skill_level_id) = $event)),
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skillLevelList, (data) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: data.id,
                            label: data.name,
                            value: data.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(data.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "skill_level_id",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Course Category",
                      modelValue: _ctx.course.course_category,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.course.course_category) = $event)),
                      filterable: "",
                      style: {"width":"100%"},
                      name: "course_category"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryList, (data) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: data.id,
                            label: data.category_name,
                            value: data.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(data.category_name), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "course_category",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _hoisted_23,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Course Sector",
                      modelValue: _ctx.course.course_sector,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.course.course_sector) = $event)),
                      filterable: "",
                      style: {"width":"100%"},
                      name: "course_sector"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sectorList, (data) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: data.id,
                            label: data.sector_name,
                            value: data.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(data.sector_name), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "course_sector",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _hoisted_26,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Unique Course",
                      modelValue: _ctx.course.x_course_name_id,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.course.x_course_name_id) = $event)),
                      filterable: "",
                      style: {"width":"100%"},
                      name: "x_course_name_id"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.aliasList, (data) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: data.id,
                            label: data.name,
                            value: data.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(data.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "x_course_name_id",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.course.course_name,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.course.course_name) = $event)),
                      name: "course_name",
                      class: "form-control"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "course_name",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _hoisted_30,
                    _createVNode(_component_Field, {
                      name: "entity_name",
                      class: "form-control",
                      modelValue: _ctx.course.code,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.course.code) = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "code",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _hoisted_33,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.course.total_target_batches,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.course.total_target_batches) = $event)),
                      name: "total_target_batches",
                      class: "form-control",
                      type: "number"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "total_target_batches",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _hoisted_35,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.course.trainee_per_batch,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.course.trainee_per_batch) = $event)),
                      name: "trainee_per_batch",
                      class: "form-control",
                      type: "number"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "trainee_per_batch",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _hoisted_37,
                    _createVNode(_component_Field, {
                      type: "number",
                      modelValue: _ctx.course.month,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.course.month) = $event)),
                      name: "month",
                      class: "form-control",
                      value: ""
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "month",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    _hoisted_40,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.course.total_target_trainee,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.course.total_target_trainee) = $event)),
                      name: "total_target_trainee",
                      class: "form-control",
                      type: "number",
                      onBlur: _cache[17] || (_cache[17] = ($event: any) => (_ctx.totalcourseCost())),
                      onChange: _cache[18] || (_cache[18] = ($event: any) => (_ctx.totalcourseCost()))
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "total_target_trainee",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_41, [
                    _hoisted_42,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.course.unit_cost_total,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.course.unit_cost_total) = $event)),
                      name: "unit_cost_total",
                      type: "number",
                      class: "form-control",
                      onBlur: _cache[20] || (_cache[20] = ($event: any) => (_ctx.totalcourseCost())),
                      onChange: _cache[21] || (_cache[21] = ($event: any) => (_ctx.totalcourseCost()))
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "unit_cost_total",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_43, [
                    _hoisted_44,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.course.total_course_cost,
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.course.total_course_cost) = $event)),
                      type: "number",
                      name: "total_course_cost",
                      class: "form-control",
                      disabled: ""
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "total_course_cost",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("div", _hoisted_46, [
                    _hoisted_47,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.course.min_day_per_month,
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.course.min_day_per_month) = $event)),
                      name: "min_day_per_month",
                      class: "form-control",
                      type: "number"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "min_day_per_month",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _hoisted_49,
                    _createVNode(_component_Field, {
                      type: "number",
                      modelValue: _ctx.course.hour,
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.course.hour) = $event)),
                      name: "hour",
                      class: "form-control"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "hour",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_50, [
                    _hoisted_51,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.course.day,
                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.course.day) = $event)),
                      name: "day",
                      class: "form-control",
                      type: "number"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "day",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_52, [
                    _hoisted_53,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.course.session,
                      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.course.session) = $event)),
                      name: "session",
                      class: "form-control",
                      type: "number"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "session",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_54, [
                    _hoisted_55,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.course.term,
                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.course.term) = $event)),
                      onBlur: _ctx.courseTerm,
                      name: "term",
                      class: "form-control",
                      value: "",
                      type: "number"
                    }, null, 8, ["modelValue", "onBlur"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "term",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_56, [
                  _createElementVNode("div", _hoisted_57, [
                    _hoisted_58,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.course.min_age,
                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.course.min_age) = $event)),
                      name: "min_age",
                      class: "form-control",
                      type: "number"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "min_age",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_59, [
                    _hoisted_60,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.course.max_age,
                      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.course.max_age) = $event)),
                      name: "max_age",
                      class: "form-control",
                      type: "number"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_61, [
                    _hoisted_62,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.course.age_grace_in_month,
                      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.course.age_grace_in_month) = $event)),
                      name: "age_grace_in_month",
                      class: "form-control",
                      type: "number"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "age_grace_in_month",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("div", _hoisted_64, [
                    _hoisted_65,
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.course.course_objective) = $event)),
                      name: "course_objective",
                      style: {"display":"block","padding":"0.75rem 1rem","font-size":"1.1rem","font-weight":"500","line-height":"1.5","color":"#181c32","background-color":"#ffffff","background-clip":"padding-box","appearance":"none","border-radius":"0.475rem","box-shadow":"none !important","transition":"border-color 0.15s ease-in-out,\r\n                        box-shadow 0.15s ease-in-out","width":"100%","height":"20vh !important","border":"1px solid #1db78d !important"}
                    }, null, 512), [
                      [_vModelText, _ctx.course.course_objective]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_66, [
                    _hoisted_67,
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.course.entry_qualification) = $event)),
                      name: "entry_qualification",
                      style: {"display":"block","padding":"0.75rem 1rem","font-size":"1.1rem","font-weight":"500","line-height":"1.5","color":"#181c32","background-color":"#ffffff","background-clip":"padding-box","appearance":"none","border-radius":"0.475rem","box-shadow":"none !important","transition":"border-color 0.15s ease-in-out,\r\n                        box-shadow 0.15s ease-in-out","width":"100%","height":"20vh !important","border":"1px solid #1db78d !important"}
                    }, null, 512), [
                      [_vModelText, _ctx.course.entry_qualification]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_68, [
                  _createElementVNode("div", _hoisted_69, [
                    _hoisted_70,
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.course.certification_authority) = $event)),
                      name: "certification_authority",
                      rows: "4",
                      class: "form-control"
                    }, null, 512), [
                      [_vModelText, _ctx.course.certification_authority]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_71, [
                  _createElementVNode("div", _hoisted_72, [
                    _createElementVNode("label", _hoisted_73, [
                      _createVNode(_component_Field, {
                        type: "checkbox",
                        class: "form-check-input",
                        name: "isStipendCourse",
                        value: "0",
                        onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.isStipendCourseCheck($event)))
                      }),
                      _hoisted_74
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_75, [
                    _createElementVNode("label", _hoisted_76, [
                      _createVNode(_component_Field, {
                        type: "checkbox",
                        class: "form-check-input",
                        name: "isManagementCourse",
                        value: "0",
                        onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.isManagementCourseCheck($event)))
                      }),
                      _hoisted_77
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_78, [
                    _createElementVNode("label", _hoisted_79, [
                      _createVNode(_component_Field, {
                        type: "checkbox",
                        class: "form-check-input",
                        name: "isEmploymentEligible",
                        value: "0",
                        onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.isEmploymentCourseCheck($event)))
                      }),
                      _hoisted_80
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_81, [
                    _createElementVNode("label", _hoisted_82, [
                      _createVNode(_component_Field, {
                        type: "checkbox",
                        class: "form-check-input",
                        name: "isReassessmentEnabled",
                        value: "0",
                        onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.isReassessmentCheck($event)))
                      }),
                      _hoisted_83
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_84, [
                    _createElementVNode("label", _hoisted_85, [
                      _createVNode(_component_Field, {
                        type: "checkbox",
                        class: "form-check-input",
                        name: "isTotCourse",
                        value: "0",
                        onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.isToTCheck($event)))
                      }),
                      _hoisted_86
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      (_ctx.showCourseTerm)
        ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
            _hoisted_88,
            _createElementVNode("div", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courseTermCount, (i) => {
                return (_openBlock(), _createElementBlock("div", { key: i }, [
                  _createElementVNode("div", _hoisted_89, [
                    _createElementVNode("div", _hoisted_90, [
                      _createElementVNode("div", _hoisted_91, [
                        _createElementVNode("div", _hoisted_92, [
                          _createElementVNode("div", _hoisted_93, [
                            _hoisted_94,
                            _createVNode(_component_Field, {
                              type: "number",
                              modelValue: _ctx.terms.no[i],
                              "onUpdate:modelValue": ($event: any) => ((_ctx.terms.no[i]) = $event),
                              name: `terms[${i}].no`,
                              class: "form-control",
                              value: i,
                              readonly: ""
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "value"])
                          ]),
                          _createElementVNode("div", _hoisted_95, [
                            _hoisted_96,
                            _createVNode(_component_Field, {
                              type: "number",
                              modelValue: _ctx.terms.month[i],
                              "onUpdate:modelValue": ($event: any) => ((_ctx.terms.month[i]) = $event),
                              name: `terms[${i}].month`,
                              class: "form-control"
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "name"])
                          ]),
                          _createElementVNode("div", _hoisted_97, [
                            _hoisted_98,
                            _createVNode(_component_Field, {
                              type: "number",
                              modelValue: _ctx.terms.day[i],
                              "onUpdate:modelValue": ($event: any) => ((_ctx.terms.day[i]) = $event),
                              name: `ter[${i}].day`,
                              class: "form-control"
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "name"])
                          ]),
                          _createElementVNode("div", _hoisted_99, [
                            _hoisted_100,
                            _createVNode(_component_Field, {
                              type: "number",
                              modelValue: _ctx.terms.session[i],
                              "onUpdate:modelValue": ($event: any) => ((_ctx.terms.session[i]) = $event),
                              name: `terms[${i}].session`,
                              class: "form-control"
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "name"])
                          ]),
                          _createElementVNode("div", _hoisted_101, [
                            _hoisted_102,
                            _createVNode(_component_Field, {
                              type: "number",
                              modelValue: _ctx.terms.hour[i],
                              "onUpdate:modelValue": ($event: any) => ((_ctx.terms.hour[i]) = $event),
                              name: `terms[${i}].hour`,
                              class: "form-control"
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "name"])
                          ]),
                          _createElementVNode("div", _hoisted_103, [
                            _hoisted_104,
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.terms.class_type[i],
                              "onUpdate:modelValue": ($event: any) => ((_ctx.terms.class_type[i]) = $event),
                              name: `terms[${i}].class_type`,
                              class: "form-select-solid",
                              placeholder: "Select Class Type",
                              style: {"width":"100%"},
                              filterable: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_option, {
                                  label: "Class Work",
                                  value: "1"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Class Work")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_option, {
                                  label: "Internship",
                                  value: "2"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Internship")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 2
                            }, 1032, ["modelValue", "onUpdate:modelValue", "name"])
                          ]),
                          _createElementVNode("div", _hoisted_105, [
                            _hoisted_106,
                            _createVNode(_component_Field, {
                              type: "number",
                              modelValue: _ctx.terms.week[i],
                              "onUpdate:modelValue": ($event: any) => ((_ctx.terms.week[i]) = $event),
                              name: `terms[${i}].week_session`,
                              class: "form-control"
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "name"])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_107, [
        _hoisted_108,
        _createElementVNode("div", _hoisted_109, [
          _createElementVNode("div", _hoisted_110, [
            _createElementVNode("div", _hoisted_111, [
              _createElementVNode("div", _hoisted_112, [
                _createElementVNode("div", _hoisted_113, [
                  _createElementVNode("div", _hoisted_114, [
                    _hoisted_115,
                    _createVNode(_component_Field, {
                      type: "number",
                      modelValue: _ctx.configuration.e_grace,
                      "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.configuration.e_grace) = $event)),
                      name: "e_grace",
                      class: "form-control"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "e_grace",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_116, [
                    _hoisted_117,
                    _createVNode(_component_Field, {
                      type: "number",
                      modelValue: _ctx.configuration.dropout_below_perc,
                      "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.configuration.dropout_below_perc) = $event)),
                      name: "dropout_below_perc\t",
                      class: "form-control"
                    }, null, 8, ["modelValue"]),
                    _hoisted_118,
                    _createVNode(_component_ErrorMessage, {
                      name: "dropout_below_perc\t",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_119, [
                    _hoisted_120,
                    _createVNode(_component_Field, {
                      type: "number",
                      modelValue: _ctx.configuration.dropout_rep_perc_per_batch,
                      "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.configuration.dropout_rep_perc_per_batch) = $event)),
                      name: "dropout_rep_perc_per_batch\t",
                      class: "form-control"
                    }, null, 8, ["modelValue"]),
                    _hoisted_121,
                    _createVNode(_component_ErrorMessage, {
                      name: "dropout_rep_perc_per_batch\t",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_122, [
                  _createElementVNode("div", _hoisted_123, [
                    _hoisted_124,
                    _createVNode(_component_Field, {
                      type: "number",
                      modelValue: _ctx.configuration.emp_bill_claim_perc,
                      "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.configuration.emp_bill_claim_perc) = $event)),
                      name: "emp_bill_claim_perc",
                      class: "form-control"
                    }, null, 8, ["modelValue"]),
                    _hoisted_125
                  ]),
                  _createElementVNode("div", _hoisted_126, [
                    _createElementVNode("label", _hoisted_127, [
                      _createVNode(_component_Field, {
                        type: "checkbox",
                        class: "form-check-input",
                        name: "assessment_applicable",
                        onClick: _cache[43] || (_cache[43] = ($event: any) => (_ctx.isAssesmentCheck($event))),
                        value: "0"
                      }),
                      _hoisted_128
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_129, [
                    _createElementVNode("label", _hoisted_130, [
                      _createVNode(_component_Field, {
                        type: "checkbox",
                        class: "form-check-input",
                        name: "certification_applicable",
                        onClick: _cache[44] || (_cache[44] = ($event: any) => (_ctx.isCertificationCheck($event))),
                        value: "0"
                      }),
                      _hoisted_131
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_132, [
        _createElementVNode("div", _hoisted_133, [
          _hoisted_134,
          _createElementVNode("div", _hoisted_135, [
            _createElementVNode("div", _hoisted_136, [
              _createElementVNode("label", _hoisted_137, [
                _hoisted_138,
                (this.percentageInfo)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_139, _toDisplayString(this.percentageInfo) + "% ", 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_140, " 0% "))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_141, [
          _createElementVNode("div", _hoisted_142, [
            _createElementVNode("div", _hoisted_143, [
              _createElementVNode("div", _hoisted_144, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (i) => {
                  return _createElementVNode("div", { key: i }, [
                    _createElementVNode("div", _hoisted_145, [
                      _createElementVNode("div", _hoisted_146, [
                        _hoisted_147,
                        _createVNode(_component_Field, {
                          modelValue: _ctx.bills.x_claim_milestone_id[i],
                          "onUpdate:modelValue": ($event: any) => ((_ctx.bills.x_claim_milestone_id[i]) = $event),
                          name: `bills[${i}].x_claim_milestone_id`,
                          type: "string",
                          value: `CLAIM-${i}`,
                          class: "form-control form-control-sm",
                          readonly: ""
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "value"])
                      ]),
                      _createElementVNode("div", _hoisted_148, [
                        _hoisted_149,
                        _createVNode(_component_el_select, {
                          class: "form-select-solid",
                          placeholder: "Select Training Milestone",
                          modelValue: _ctx.bills.x_training_milestone_id[i],
                          "onUpdate:modelValue": ($event: any) => ((_ctx.bills.x_training_milestone_id[i]) = $event),
                          name: `bills[${i}].x_training_milestone_id`,
                          filterable: "",
                          style: {"width":"100%"},
                          disabled: ""
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.milestoneList, (data) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: data.id,
                                label: data.milestone_name,
                                value: data.id
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(data.milestone_name), 1)
                                ]),
                                _: 2
                              }, 1032, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue", "name"])
                      ]),
                      _createElementVNode("div", _hoisted_150, [
                        _hoisted_151,
                        _createVNode(_component_Field, {
                          type: "number",
                          modelValue: _ctx.bills.claim_percentage[i],
                          "onUpdate:modelValue": ($event: any) => ((_ctx.bills.claim_percentage[i]) = $event),
                          name: `bills[${i}].claim_percentage`,
                          class: "form-control form-control-sm"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "name"])
                      ]),
                      _createElementVNode("div", _hoisted_152, [
                        _hoisted_153,
                        _createVNode(_component_Field, {
                          type: "number",
                          modelValue: _ctx.bills.adj_adv_reduction_perc[i],
                          "onUpdate:modelValue": ($event: any) => ((_ctx.bills.adj_adv_reduction_perc[i]) = $event),
                          name: `bills[${i}].adj_adv_reduction_perc`,
                          class: "form-control form-control-sm"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "name"])
                      ]),
                      _hoisted_154,
                      _createElementVNode("div", _hoisted_155, [
                        _createElementVNode("label", _hoisted_156, [
                          (this.bills.claim_percentage[i])
                            ? (_openBlock(), _createElementBlock("span", _hoisted_157, _toDisplayString(this.course.unit_cost_total *
                          (this.bills.claim_percentage[i] / 100)), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_158, " 00 "))
                        ])
                      ])
                    ])
                  ])
                }), 64))
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_159, [
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              "data-kt-indicator": _ctx.loading ? 'on' : null,
              class: "btn btn-lg btn-success",
              type: "submit",
              onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.formSubmit()))
            }, [
              (!_ctx.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_161, [
                    _createTextVNode(" Submit "),
                    _createElementVNode("span", _hoisted_162, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_163, [
                    _createTextVNode(" Please wait... "),
                    _hoisted_164
                  ]))
                : _createCommentVNode("", true)
            ], 8, _hoisted_160)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["validation-schema"]))
}